import React from 'react'
import styled from 'styled-components'
import { PlusSquareOutlined, CopyOutlined } from '@ant-design/icons'
import { Button, Card, Col, Image, Row, Space, Table, Tag, message } from 'antd'
import { Product } from '@a4b/api/src/modules/Monetisation/Puja/types'

interface Props {
  onCreateNew: () => void
  onStatusChange: (status: boolean) => void
  triggerEdit: (temple: Product) => void
  dataSource: any[]
  rowSelectionConfig: any
}

const Container = styled(Card)`
  display: flex;
  flex-direction: column;

  .ant-card-body {
    flex-grow: 1;
  }
`
const BodyContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: start;
  flex-wrap: wrap;
  width: 100%;
  height: 100%;
`

const ManageItemsPage: React.FC<Props> = ({
  onCreateNew,
  triggerEdit,
  dataSource,
}) => {
  const dataColumns = [
    {
      title: 'Name',
      dataIndex: 'title',
      key: 'title',
      width: '20%',
    },
    {
      title: 'Slug',
      dataIndex: 'slug',
      key: 'slug',
      width: '18%',
      render: (text: string) => (
        <Space>
          {text}
          <Button
            type="text"
            icon={<CopyOutlined />}
            onClick={() => {
              navigator.clipboard.writeText(text);
              message.success('Slug copied to clipboard');
            }}
          />
        </Space>
      ),
    },
    {
      title: 'Description',
      dataIndex: 'description',
      key: 'description',
      width: '25%',
      ellipsis: true,
      render: (text: any,) => {
        return <span>{text}</span>
      },
    },
    {
      title: 'Price',
      dataIndex: 'price',
      key: 'price',
    },
    {
      title: 'Item type',
      dataIndex: 'item_type',
      key: 'item_type',
    },
    {
      title: 'Language',
      dataIndex: 'language_code',
      key: 'language_code',
      render: (text: any,) => {
        return <Tag>{text}</Tag>
      },
    },
    {
      title: 'Image',
      dataIndex: 'image_url',
      key: 'image_url',
      render: (text: any,) => {
        return <Image width={50} height={50} src={text}></Image>
      },
    },
    {
      title: 'Action',
      key: 'action',
      render: (text: any, record: any,) => (
        <Row>
          <Col span={12}>
            <Button type='link' onClick={() => triggerEdit(record)}>
              Edit
            </Button>
          </Col>
        </Row>
      ),
    },
  ]
  return (
    <Container title='Manage Products' style={{ width: '100%' }}>
      <Space direction={'vertical'} style={{ width: '100%' }}></Space>
      <BodyContainer>
        <Button type='text' onClick={onCreateNew}>
          <PlusSquareOutlined /> Add New Product
        </Button>

        <Table
          columns={dataColumns}
          dataSource={dataSource}
          pagination={{ defaultPageSize: 8 }}
        />
      </BodyContainer>
    </Container>
  )
}

export default ManageItemsPage
